import React from 'react'
import { IKnockStatusIcon } from '@user/store/knockStatus/typings'

type IconComponent = React.JSX.Element

type GetPngIconsProps = {
  color?: string
}

const getPngIcons = ({ color = '#19305A' }: GetPngIconsProps) => {
  const Block = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.58 18 2 14.42 2 10C2 8.15 2.63 6.45 3.69 5.1L14.9 16.31C13.55 17.37 11.85 18 10 18ZM16.31 14.9L5.1 3.69C6.45 2.63 8.15 2 10 2C14.42 2 18 5.58 18 10C18 11.85 17.37 13.55 16.31 14.9Z"
        fill={color}
      />
    </svg>
  )

  const StarOutlined = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 20 19"
      fill="none"
    >
      <path
        d="M20 7.24L12.81 6.62L10 0L7.19 6.63L0 7.24L5.46 11.97L3.82 19L10 15.27L16.18 19L14.55 11.97L20 7.24ZM10 13.4L6.24 15.67L7.24 11.39L3.92 8.51L8.3 8.13L10 4.1L11.71 8.14L16.09 8.52L12.77 11.4L13.77 15.68L10 13.4Z"
        fill={color}
      />
    </svg>
  )

  const FavoriteBorder = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 -1.5 20 19"
      fill="none"
    >
      <path
        d="M14.5 0C12.76 0 11.09 0.81 10 2.09C8.91 0.81 7.24 0 5.5 0C2.42 0 0 2.42 0 5.5C0 9.28 3.4 12.36 8.55 17.04L10 18.35L11.45 17.03C16.6 12.36 20 9.28 20 5.5C20 2.42 17.58 0 14.5 0ZM10.1 15.55L10 15.65L9.9 15.55C5.14 11.24 2 8.39 2 5.5C2 3.5 3.5 2 5.5 2C7.04 2 8.54 2.99 9.07 4.36H10.94C11.46 2.99 12.96 2 14.5 2C16.5 2 18 3.5 18 5.5C18 8.39 14.86 11.24 10.1 15.55Z"
        fill={color}
      />
    </svg>
  )

  const RadioButtonUnchecked = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.58 18 2 14.42 2 10C2 5.58 5.58 2 10 2C14.42 2 18 5.58 18 10C18 14.42 14.42 18 10 18Z"
        fill={color}
      />
    </svg>
  )

  const CrossIcon = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 14 14"
      fill="none"
    >
      <path
        d="M3 3 L11 11 M11 3 L3 11"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  )

  const SentimentVeryDissatisfied = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M9.99 0C4.47 0 0 4.48 0 10C0 15.52 4.47 20 9.99 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 9.99 0ZM10 18C5.58 18 2 14.42 2 10C2 5.58 5.58 2 10 2C14.42 2 18 5.58 18 10C18 14.42 14.42 18 10 18ZM10 12C7.67 12 5.68 13.45 4.88 15.5H6.55C7.24 14.31 8.52 13.5 10 13.5C11.48 13.5 12.75 14.31 13.45 15.5H15.12C14.32 13.45 12.33 12 10 12Z"
        fill={color}
      />
      <path
        d="M6.5 9C7.32843 9 8 8.32843 8 7.5C8 6.67157 7.32843 6 6.5 6C5.67157 6 5 6.67157 5 7.5C5 8.32843 5.67157 9 6.5 9Z"
        fill={color}
      />
      <path
        d="M13.5 9C14.3284 9 15 8.32843 15 7.5C15 6.67157 14.3284 6 13.5 6C12.6716 6 12 6.67157 12 7.5C12 8.32843 12.6716 9 13.5 9Z"
        fill={color}
      />
    </svg>
  )

  const SentimentNeutral = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M9.99 0C4.47 0 0 4.48 0 10C0 15.52 4.47 20 9.99 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 9.99 0ZM10 18C5.58 18 2 14.42 2 10C2 5.58 5.58 2 10 2C14.42 2 18 5.58 18 10C18 14.42 14.42 18 10 18Z"
        fill={color}
      />
      <path
        d="M6.5 9C7.32843 9 8 8.32843 8 7.5C8 6.67157 7.32843 6 6.5 6C5.67157 6 5 6.67157 5 7.5C5 8.32843 5.67157 9 6.5 9Z"
        fill={color}
      />
      <path
        d="M13.5 9C14.3284 9 15 8.32843 15 7.5C15 6.67157 14.3284 6 13.5 6C12.6716 6 12 6.67157 12 7.5C12 8.32843 12.6716 9 13.5 9Z"
        fill={color}
      />
      <path d="M7 13.5H13V14.5H7V13.5Z" fill={color} />
    </svg>
  )

  const SentimentSatisfiedAlt = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M9.99 0C4.47 0 0 4.48 0 10C0 15.52 4.47 20 9.99 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 9.99 0ZM10 18C5.58 18 2 14.42 2 10C2 5.58 5.58 2 10 2C14.42 2 18 5.58 18 10C18 14.42 14.42 18 10 18ZM10 14C9.27 14 8.62 13.82 8.04 13.48C7.92 13.62 7.18 14.46 7.03 14.63C7.89 15.18 8.9 15.5 10 15.5C11.11 15.5 12.12 15.17 12.98 14.62C12.01 13.53 12.97 14.6 11.97 13.47C11.38 13.82 10.73 14 10 14Z"
        fill={color}
      />
      <path
        d="M6.5 9C7.32843 9 8 8.32843 8 7.5C8 6.67157 7.32843 6 6.5 6C5.67157 6 5 6.67157 5 7.5C5 8.32843 5.67157 9 6.5 9Z"
        fill={color}
      />
      <path
        d="M13.5 9C14.3284 9 15 8.32843 15 7.5C15 6.67157 14.3284 6 13.5 6C12.6716 6 12 6.67157 12 7.5C12 8.32843 12.6716 9 13.5 9Z"
        fill={color}
      />
    </svg>
  )

  const Pets = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 20 19"
      fill="none"
    >
      <path
        d="M15.34 11.86C14.47 10.84 13.74 9.97 12.86 8.95C12.4 8.41 11.81 7.87 11.11 7.63C11 7.59 10.89 7.56 10.78 7.54C10.53 7.5 10.26 7.5 9.99999 7.5C9.73999 7.5 9.46999 7.5 9.20999 7.55C9.09999 7.57 8.98999 7.6 8.87999 7.64C8.17999 7.88 7.59999 8.42 7.12999 8.96C6.25999 9.98 5.52999 10.85 4.64999 11.87C3.33999 13.18 1.72999 14.63 2.02999 16.66C2.31999 17.68 3.04999 18.69 4.35999 18.98C5.08999 19.13 7.41999 18.54 9.89999 18.54H10.08C12.56 18.54 14.89 19.12 15.62 18.98C16.93 18.69 17.66 17.67 17.95 16.66C18.26 14.62 16.65 13.17 15.34 11.86Z"
        fill={color}
      />
      <path
        d="M17.5 9C18.8807 9 20 7.88071 20 6.5C20 5.11929 18.8807 4 17.5 4C16.1193 4 15 5.11929 15 6.5C15 7.88071 16.1193 9 17.5 9Z"
        fill={color}
      />
      <path
        d="M13 5C14.3807 5 15.5 3.88071 15.5 2.5C15.5 1.11929 14.3807 0 13 0C11.6193 0 10.5 1.11929 10.5 2.5C10.5 3.88071 11.6193 5 13 5Z"
        fill={color}
      />
      <path
        d="M7 5C8.38071 5 9.5 3.88071 9.5 2.5C9.5 1.11929 8.38071 0 7 0C5.61929 0 4.5 1.11929 4.5 2.5C4.5 3.88071 5.61929 5 7 5Z"
        fill={color}
      />
      <path
        d="M2.5 9C3.88071 9 5 7.88071 5 6.5C5 5.11929 3.88071 4 2.5 4C1.11929 4 0 5.11929 0 6.5C0 7.88071 1.11929 9 2.5 9Z"
        fill={color}
      />
    </svg>
  )

  const CloudQueue = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 24 16"
      fill="none"
    >
      <path
        d="M19.35 6.04C18.67 2.59 15.64 0 12 0C9.11 0 6.61 1.64 5.36 4.04C2.35 4.36 0 6.9 0 10C0 13.31 2.69 16 6 16H19C21.76 16 24 13.76 24 11C24 8.36 21.95 6.22 19.35 6.04ZM19 14H6C3.79 14 2 12.21 2 10C2 7.79 3.79 6 6 6C8.21 6 10 7.79 10 10H12C12 7.24 10.14 4.92 7.6 4.22C8.61 2.88 10.2 2 12 2C15.03 2 17.5 4.47 17.5 7.5V8H19C20.65 8 22 9.35 22 11C22 12.65 20.65 14 19 14Z"
        fill={color}
      />
    </svg>
  )

  const AcUnit = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M20 9H15.83L19.07 5.76L17.66 4.34L13 9H11V7L15.66 2.34L14.24 0.93L11 4.17V0H9V4.17L5.76 0.93L4.34 2.34L9 7V9H7L2.34 4.34L0.93 5.76L4.17 9H0V11H4.17L0.93 14.24L2.34 15.66L7 11H9V13L4.34 17.66L5.76 19.07L9 15.83V20H11V15.83L14.24 19.07L15.66 17.66L11 13V11H13L17.66 15.66L19.07 14.24L15.83 11H20V9Z"
        fill={color}
      />
    </svg>
  )

  const AttachMoney = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 10 18"
      fill="none"
    >
      <path
        d="M5.48 7.9C3.21 7.31 2.48 6.7 2.48 5.75C2.48 4.66 3.49 3.9 5.18 3.9C6.96 3.9 7.62 4.75 7.68 6H9.89C9.82 4.28 8.77 2.7 6.68 2.19V0H3.68V2.16C1.74 2.58 0.18 3.84 0.18 5.77C0.18 8.08 2.09 9.23 4.88 9.9C7.38 10.5 7.88 11.38 7.88 12.31C7.88 13 7.39 14.1 5.18 14.1C3.12 14.1 2.31 13.18 2.2 12H0C0.12 14.19 1.76 15.42 3.68 15.83V18H6.68V15.85C8.63 15.48 10.18 14.35 10.18 12.3C10.18 9.46 7.75 8.49 5.48 7.9Z"
        fill={color}
      />
    </svg>
  )

  const RocketLaunch = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="-2 0 22 18"
      fill="none"
    >
      <path
        d="M7.19 3.86415C5.15 6.15415 3.75 9.44414 3.62 9.75414L0 8.20414L4.05 4.15415C4.52 3.68415 5.2 3.47415 5.86 3.60415L7.19 3.86415ZM9.17 14.5141C9.17 14.5141 12.91 12.9641 15.06 10.8141C20.46 5.41414 19.56 1.19415 19.27 0.244145C18.32 -0.0558547 14.1 -0.945855 8.7 4.45415C6.55 6.60415 5 10.3441 5 10.3441L9.17 14.5141ZM15.65 12.3241C13.36 14.3641 10.07 15.7641 9.76 15.8941L11.31 19.5141L15.36 15.4641C15.83 14.9941 16.04 14.3141 15.91 13.6541L15.65 12.3241ZM7 15.5141C7 16.3441 6.66 17.0941 6.12 17.6341C4.94 18.8141 0 19.5141 0 19.5141C0 19.5141 0.7 14.5741 1.88 13.3941C2.42 12.8541 3.17 12.5141 4 12.5141C5.66 12.5141 7 13.8541 7 15.5141ZM11 6.51415C11 5.41415 11.9 4.51415 13 4.51415C14.1 4.51415 15 5.41415 15 6.51415C15 7.61415 14.1 8.51414 13 8.51414C11.9 8.51414 11 7.61415 11 6.51415Z"
        fill={color}
      />
    </svg>
  )

  const ThumbUpOutlined = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="-2 1 22 18"
      fill="none"
    >
      <path
        d="M11.11 3.72L10.54 6.61C10.42 7.2 10.58 7.81 10.96 8.27C11.34 8.73 11.9 9 12.5 9H18V10.08L15.43 16H7.34C7.16 16 7 15.84 7 15.66V7.82L11.11 3.72ZM12 0L5.59 6.41C5.21 6.79 5 7.3 5 7.83V15.66C5 16.95 6.05 18 7.34 18H15.44C16.15 18 16.8 17.63 17.16 17.03L19.83 10.88C19.94 10.63 20 10.36 20 10.08V9C20 7.9 19.1 7 18 7H12.5L13.42 2.35C13.47 2.13 13.44 1.89 13.34 1.69C13.11 1.24 12.82 0.83 12.46 0.47L12 0ZM2 7H0V18H2C2.55 18 3 17.55 3 17V8C3 7.45 2.55 7 2 7Z"
        fill={color}
      />
    </svg>
  )

  const ThumbDownOutlined = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 -1.5 20 18"
      fill="none"
    >
      <path
        d="M8.89 14.28L9.46 11.39C9.58 10.8 9.42 10.19 9.04 9.73C8.66 9.27 8.1 9 7.5 9H2V7.92L4.57 2H12.66C12.84 2 13 2.16 13 2.34V10.18L8.89 14.28ZM8 18L14.41 11.59C14.79 11.21 15 10.7 15 10.17V2.34C15 1.05 13.95 0 12.66 0H4.56C3.85 0 3.2 0.37 2.84 0.97L0.17 7.12C0.0600001 7.37 0 7.64 0 7.92V9C0 10.1 0.9 11 2 11H7.5L6.58 15.65C6.53 15.87 6.56 16.11 6.66 16.31C6.89 16.76 7.18 17.17 7.54 17.53L8 18ZM18 11H20V0H18C17.45 0 17 0.45 17 1V10C17 10.55 17.45 11 18 11Z"
        fill={color}
      />
    </svg>
  )

  const Check = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 -1 18 14"
      fill="none"
    >
      <path
        d="M5.59 10.58L1.42 6.41L0 7.82L5.59 13.41L17.59 1.41L16.18 0L5.59 10.58Z"
        fill={color}
      />
    </svg>
  )

  const WarningAmber = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 2 22 19"
      fill="none"
    >
      <path d="M12 8H10V13H12V8Z" fill={color} />
      <path d="M12 14H10V16H12V14Z" fill={color} />
      <path
        d="M11 3.99L18.53 17H3.47L11 3.99ZM11 0L0 19H22L11 0Z"
        fill={color}
      />
    </svg>
  )

  const Filter1 = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="-2 0 22 18"
      fill="none"
    >
      <path
        d="M16 0H2C0.9 0 0 0.9 0 2V16C0 17.1 0.9 18 2 18H16C17.1 18 18 17.1 18 16V2C18 0.9 17.1 0 16 0ZM11 14H9V6H7V4H11V14Z"
        fill={color}
      />
    </svg>
  )

  const Filter2 = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="-2 0 22 18"
      fill="none"
    >
      <path
        d="M16 0H2C0.9 0 0 0.9 0 2V16C0 17.1 0.9 18 2 18H16C17.1 18 18 17.1 18 16V2C18 0.9 17.1 0 16 0ZM12 8C12 9.11 11.1 10 10 10H8V12H12V14H6V10C6 8.89 6.9 8 8 8H10V6H6V4H10C11.1 4 12 4.89 12 6V8Z"
        fill={color}
      />
    </svg>
  )

  const Filter3 = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="-2 0 22 18"
      fill="none"
    >
      <path
        d="M16 0H2C0.9 0 0 0.9 0 2V16C0 17.1 0.9 18 2 18H16C17.1 18 18 17.1 18 16V2C18 0.9 17.1 0 16 0ZM12 7.5C12 8.33 11.33 9 10.5 9C11.33 9 12 9.67 12 10.5V12C12 13.11 11.1 14 10 14H6V12H10V10H8V8H10V6H6V4H10C11.1 4 12 4.89 12 6V7.5Z"
        fill={color}
      />
    </svg>
  )

  const Filter4 = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="-2 0 22 18"
      fill="none"
    >
      <path
        d="M16 0H2C0.9 0 0 0.9 0 2V16C0 17.1 0.9 18 2 18H16C17.1 18 18 17.1 18 16V2C18 0.9 17.1 0 16 0ZM12 14H10V10H6V4H8V8H10V4H12V14Z"
        fill={color}
      />
    </svg>
  )

  return {
    Block,
    StarOutlined,
    FavoriteBorder,
    RadioButtonUnchecked,
    CrossIcon,
    SentimentVeryDissatisfied,
    SentimentNeutral,
    SentimentSatisfiedAlt,
    Pets,
    CloudQueue,
    AcUnit,
    AttachMoney,
    RocketLaunch,
    ThumbUpOutlined,
    ThumbDownOutlined,
    Check,
    WarningAmber,
    Filter1,
    Filter2,
    Filter3,
    Filter4,
  }
}

export const useKnockStatusIcons = () => {
  const getIconMap = (color?: string): Record<number, IconComponent> => {
    const {
      Block,
      StarOutlined,
      FavoriteBorder,
      RadioButtonUnchecked,
      CrossIcon,
      SentimentVeryDissatisfied,
      SentimentNeutral,
      SentimentSatisfiedAlt,
      Pets,
      CloudQueue,
      AcUnit,
      AttachMoney,
      RocketLaunch,
      ThumbUpOutlined,
      ThumbDownOutlined,
      Check,
      WarningAmber,
      Filter1,
      Filter2,
      Filter3,
      Filter4,
    } = getPngIcons({ color })

    return {
      0: Block,
      [IKnockStatusIcon.Star]: StarOutlined,
      [IKnockStatusIcon.Heart]: FavoriteBorder,
      [IKnockStatusIcon.Circle]: RadioButtonUnchecked,
      [IKnockStatusIcon.Cross]: CrossIcon,
      [IKnockStatusIcon.SadFace]: SentimentVeryDissatisfied,
      [IKnockStatusIcon.NeutralFace]: SentimentNeutral,
      [IKnockStatusIcon.HappyFace]: SentimentSatisfiedAlt,
      [IKnockStatusIcon.Paw]: Pets,
      [IKnockStatusIcon.Cloud]: CloudQueue,
      [IKnockStatusIcon.Snowflake]: AcUnit,
      [IKnockStatusIcon.Dollar]: AttachMoney,
      [IKnockStatusIcon.Rocket]: RocketLaunch,
      [IKnockStatusIcon.ThumbsUp]: ThumbUpOutlined,
      [IKnockStatusIcon.ThumbsDown]: ThumbDownOutlined,
      [IKnockStatusIcon.Check]: Check,
      [IKnockStatusIcon.Warning]: WarningAmber,
      [IKnockStatusIcon.Number1]: Filter1,
      [IKnockStatusIcon.Number2]: Filter2,
      [IKnockStatusIcon.Number3]: Filter3,
      [IKnockStatusIcon.Number4]: Filter4,
    }
  }

  const getIcon = (icon: number | null, color?: string, _fontSize?: string) => {
    const iconMap = getIconMap(color)
    const IconComponent = icon !== null ? iconMap[icon] : null
    return IconComponent ? IconComponent : null
  }

  return { getIcon }
}
